<!--
  @component App — consumer entry App.
  tier:      application root (mounted by main.ts via bootApp)

  Thin shell. The ONLY place in `apps/network/consumer/` that reads
  `import.meta.env`. Mounts Styles + IdentityIO + ConsumerRoot.
  ConsumerRoot lives inside IdentityIO and owns the routing-driven
  state + auth guard + the Shell/Router chain (see ConsumerRoot.svelte).
-->
<script lang="ts">
  import Styles from "../../global/visuals/styles/Styles.svelte";
  import IdentityIO from "./accounts/IdentityIO.svelte";
  import ScopeIO from "./features/deployments/ScopeIO.svelte";
  import ConsumerRoot from "./ConsumerRoot.svelte";

  // ─── The ONLY env reads in apps/network/consumer ──────────────
  const isDev = import.meta.env.DEV === true;
  const buildVersion =
    (import.meta.env["VITE_NETWORK_VERSION"] as string | undefined) ?? "dev";

  function handleIdentityReady(): void {
    const target = document.getElementById("app");
    target?.removeAttribute("aria-busy");
    if (isDev) {
      // eslint-disable-next-line no-console
      console.log(
        `[network/consumer] IdentityIO ready · build=${buildVersion}`,
      );
    }
  }
</script>

<svelte:head>
  <title>network · consumer</title>
</svelte:head>

<Styles>
  <IdentityIO onReady={handleIdentityReady}>
    <ScopeIO>
      <ConsumerRoot />
    </ScopeIO>
  </IdentityIO>
</Styles>
